import {STATIC_IMAGE} from '../../../../config/config';
import * as css from './header.css';

interface HeaderProps {
    mainTitle?: any;
    subTitle?: string;
}

function Header({mainTitle, subTitle}: HeaderProps){
    return <css.header>
        <css.headerText>
            {mainTitle && <css.headerTitle>
                {mainTitle}
            </css.headerTitle>}
            {subTitle && <css.subTitle>
                {subTitle}
            </css.subTitle>}
        </css.headerText>
        <css.logo 
            src={`${STATIC_IMAGE}/tick_logo.jpg`}
            alt="" 
        />
    </css.header>;
}

export default Header;